import { unique } from "jquery";

class ApiHelper {

    constructor() {
        this.accessToken = null;
    }
    setToken(token) {
        this.accessToken = token;
        try {
            window.localStorage.setItem('prht', token);
        } catch (error) {
            console.error("Failed to store token in localStorage:", error);
        }
    }
    getToken() {
        let token = null;
        try {
            if (this.accessToken) {
                return (this.accessToken);
            } else {

                token = window.localStorage.getItem('prht');
                this.setToken(token);
                return token;
            }
       
/*
            // If accessToken is available and token is still null, use accessToken
            if (!token && this.accessToken) {
                token = this.accessToken;
            }

            // Fallback: Try getting msal.idtoken again if still null
            if (!token) {
                token = window.localStorage.getItem('msal.idtoken');
            }

            // Store token if found
            if (token) {
                this.setToken(token);
            }
*/
        } catch (error) {
            console.error("Failed to retrieve token from localStorage:", error);
        }

        return token;
    }


    getSavedToken() {
        const timeValue = new Date().getTime();
        if (this.delay > (timeValue - 5 * 60 * 1000)) {
            return this.accessToken;
        } else {
            this.accessToken = null;
            let data = this.getToken();
            return data;
        }
    }
    async inventoryPostCall(methodUrl, payload, throwError = false) {
        try {
            var result = await this.postCall(`api/Inventory/${methodUrl}`, payload);
            // If result is null, just return it silently
            if (result == null) {
                return null;
            }
            return result;

            return result;
        } catch ({ name, message }) {
            console.error('inventoryPostCall failed.', name, message);
            if (throwError) {
                throw new Error(message);
            }
            return null;
        }
    }

    async uploadImprint(file) {
        try {
            const formData = new FormData();
            formData.append('file', file);

            const response = await fetch('api/Inventory/uploadImprints', {
                method: 'POST',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Authorization': `Bearer ${this.getToken()}`, // Include token if required
                },
                body: formData,
            });

            if (response.ok) {
                const data = await response.json();
                return {
                    success: true,
                    data: data,
                    message: 'File uploaded successfully.',
                };
            } else {
                const errorData = await response.json();
                return {
                    success: false,
                    message: errorData?.message || 'Unexpected response from the server.',
                };
            }
        } catch (error) {
            return {
                success: false,
                message: error.message || 'An error occurred while uploading the file.',
            };
        }
    }

    async inventoryFilePostCall(methodUrl, payload, upn, returnResponseAsIs = true, throwError = false) {
        try {
            const token = this.getToken();
            let response = null;
            if (payload) {
                const formData = new FormData();
                formData.append('file', payload);
                formData.append('upn', upn);
                let option = {
                    method: 'POST',
                    headers: {
                        //'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                        'Authorization': `Bearer ${token}`
                    },
                    body: formData
                };
                const baseUrl = `api/Inventory/${methodUrl}`
                response = await fetch(baseUrl, option);
                if (returnResponseAsIs) {
                    return await response.json();
                }
                if (response.status === 200) {
                    return { success: true, data: null, warnings: null };
                }
            }
            return { success: false, data: null, warnings: null };
        } catch ({ name, message }) {
            console.error('inventoryUploadPostCall failed.', name, message);
            if (throwError) {
                throw new Error(message);
            }
            return null;
        }
    }

    async postCall(relativeUrl, payload) {
        return await this.apiCall(relativeUrl, 'POST', payload);
    }
    async apiCall(relativeUrl, method, payload) {

        const token = this.getToken();
        let option = {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': `Bearer ${token}`
            },
        };

     

        if (payload != null && payload != undefined) {
            option.body = JSON.stringify(payload);
        }
        let response = null;
        try {
            response = await fetch(relativeUrl, option);
            if (!response || response.status === 204) { // Handle null/empty response or No Content status
                return null;
            }
            let data = await response.json();
           
          
            return data;
        }
        catch ({ name, message }) {
            let responseError = response?.statusText;
            if (responseError == null || responseError == undefined) {
                responseError = 'Server Errorr';
            }

            const e = new Error('Please try again. If error continues contact System Admin.');
            e.name = responseError;
            throw e;
        }

    }

    async getStatus() {
        let data = await apiHelper.inventoryPostCall("getStatusDiscription", null);
        if (data != null && data != undefined && data.length > 0) {
            return data;
        }
        return [];
    }

    async azureSearchSuggest(query) {
        try {
            if (query.length < 2) { return []; }
            let url = '/api/search/suggest?term=' + query + '&highlights=false&fuzzy=false&numberOfRows=20&fieldName=Title_Full';
            return await this.apiCall(url, "GET", null);
        } catch ({ name, message }) {
            console.error('search suggest failed.', name, message);
            if (throwError) {
                throw new Error(message);
            }
            return [];
        }
    }

    async azureSearch(payload) {
        try {
            return await this.apiCall('/api/search/query', "POST", payload);
        } catch ({ name, message }) {
            console.error('search suggest failed.', name, message);
            if (throwError) {
                throw new Error(message);
            }
            return null;
        }
    }
    async getColumnDef() {
        try {
            let url = '/api/search/getcolumndefs';
            return await this.apiCall(url, "GET", null);
        } catch ({ name, message }) {
            console.error('search suggest failed.', name, message);
            if (throwError) {
                throw new Error(message);
            }
            return [];
        }
    }
    async handleReplaceList(newList, upn, flag = true) {

        const list = newList.map(i => i.isbn);

        try {
            await this.inventoryPostCall("setTitleList", {
                isbnList: list,
                upn: upn,
                flag: flag
            })
        } catch ({ name, message }) {
            console.error("set title list failed", name, message);
        }
    }

    async recISBNDataCall(itemList, upn, isbnData, setIsbnData, shouldReplace, duplicateISBNList = null) {
        try {

            const data = await this.inventoryPostCall("validateISBN", itemList);
            if (data != null && data.length > 0) {

                const newStringList = itemList.filter(str => str.trim() !== '' && !data.some(obj => (obj.isbn === str)));
                setIsbnData(prev => ({ ...prev, invalid: newStringList }));
                let sortData = [];

                itemList.forEach(item => {
                    let newData = data.filter(r => r.isbn == item);
                    if (newData) {
                        sortData.push(...newData);
                    }
                });

                //  setISBNList(sortData);
                await this.handleReplaceList(sortData, upn, shouldReplace);
                if (shouldReplace)
                    setIsbnData(prev => ({ ...prev, listISBN: sortData }));
                else
                    setIsbnData(prev => ({ ...prev, listISBN: [...prev.listISBN, ...sortData] }));
            }
            if (duplicateISBNList) {
                const duplicateISBNDet = await apiHelper.inventoryPostCall("validateISBN", duplicateISBNList);
                if (duplicateISBNDet != null && duplicateISBNDet.length > 0) {
                    // setDuplicateISBN(duplicateISBNDet);
                    setIsbnData(prev => ({ ...prev, duplicates: duplicateISBNDet }));
                }
                else {
                    setIsbnData(prev => ({ ...prev, duplicates: [] }));
                }
            }
        } catch (error) {
            console.error("validateISBN API erro", error);
        }

    }

    async checkForDup(itemList, upn, isbnData, setIsbnData, shouldReplace = true, duplicateISBNList = null) {
        const chunkSize = 1000;

        if (itemList && itemList.length <= chunkSize) {
            await this.recISBNDataCall(itemList, upn, isbnData, setIsbnData, shouldReplace, duplicateISBNList);
        }
        else {
            for (let i = 0; i < itemList.length; i += chunkSize) {
                const chunk = itemList.slice(i, i + chunkSize);
                const flag = i > 0 ? false : shouldReplace;
                await this.recISBNDataCall(chunk, upn, isbnData, setIsbnData, flag, duplicateISBNList);
            }
        }
        setIsbnData(prev => ({ ...prev, Loading: false }));
    }


    async ISBNValidation(inputText, upn, isbnData, setIsbnData) {
        if (typeof inputText === "string" && inputText.trim() != "") {
            setIsbnData(prev => ({ ...prev, Loading: true }));
            const itemList = inputText.split(/\s+|,/);
            const pattern = /[^a-zA-Z0-9\s,]/g;
            const uniqueElements = [];
            const duplicates = [];
            itemList.forEach(item => {
                item = item.replace(pattern, '');
                if (item != "") {
                    if (uniqueElements.includes(item) && !duplicates.includes(item)) {
                        duplicates.push(item);
                    } else {
                        uniqueElements.push(item);
                    }
                }
            });
            const uniqueList = await Array.from(new Set(uniqueElements));
            await this.checkForDup(uniqueList, upn, isbnData, setIsbnData, true, duplicates);

        }
    }
  

    async inventoryUserPostCall(methodUrl, payload, throwError = false) {
        try {
            var result = await this.postCall(`api/User/${methodUrl}`, payload);
            return result;
        } catch ({ name, message }) {
            console.error('inventoryUserPostCall failed.', name, message);
            if (throwError) {
                throw new Error(message);
            }
            return null;
        }
    }

    async ISBNCheckValidate(inputText, upn, setIsbnData, isbnData, prependISBN, fromOverview, updateSetTitle) {
        try {
            if (typeof inputText === "string" && inputText.trim() != "") {
                //      setIsbnData(prev => ({ ...prev, Loading: true }));
                const itemList = inputText.split(/\s+|,/);
                const pattern = /[^a-zA-Z0-9\s,]/g;
                const uniqueSet = [];

                itemList.forEach((item) => {
                   
                    const newItem = item.replace(pattern, '');
                    if (newItem && newItem.trim() != "") {
                        uniqueSet.push(newItem);
                    }
                });
               
                await this.ISBNCheck(uniqueSet, upn, setIsbnData, isbnData, prependISBN, fromOverview, updateSetTitle)

            }
        } catch (error){
            console.error("text validation failed");
        }
    }

    ////////////OPTIMIZATION
    //later handle for prepend**********************
    async ISBNCheck(itemList, upn, setIsbnData, isbnData, prependISBN = false, fromOverview = true, updateSetTitle = true) {
        try {
            const chunkSize = 1000;
            const seenItem = new Set();
            const validItem = new Set();
            setIsbnData(prev => ({
                ...prev,
                Loading: true
            }));
            //get a slice then pass it
            if (prependISBN) {
                for (let i = itemList.length; i > 0; i -= chunkSize) {
                    
                    const chunk = itemList.slice(Math.max(0, i - chunkSize), i);
                    chunk.forEach(item => validItem.add(item));
                    const validatedISBN = await this.inventoryPostCall("validateISBN", chunk);
                    setIsbnData(prev => (
                        {
                            ...prev,
                            listISBN: [...validatedISBN, ...prev.listISBN],
                            duplicates: [],
                            invalid:[]
                        }
                    ));
                }

            } else {
                if (fromOverview) {
 
                    for (let i = 0; i < itemList.length; i += chunkSize) {
                        const seenItemChunk = new Set();
                        const duplicates = new Set();
                        const invalid = new Set();

                        const chunk = itemList.slice(i, i + chunkSize);

                        const replaceISBNflag = i == 0;//to uppend or complete replace isbn list in existing list

                
                        if (chunk.length > 0) {
                            chunk.forEach(item => {

                                if (seenItem.has(item)) {
                                    duplicates.add(item);
                                } else {
                                    seenItem.add(item);
                                    seenItemChunk.add(item);
                                }
                            });
                        }
                        

                        if (seenItemChunk.size > 0) {
                           
                            const validatedISBN = await this.inventoryPostCall("validateISBN", [...seenItemChunk]);
                            if (validatedISBN == undefined || validatedISBN == null) {
                                continue;
                            }
                            
                            seenItemChunk.forEach(i => {
                         
                                const newItem = validatedISBN.some(item => item.isbn == i);
                 
                                if (!newItem) {
                                    invalid.add(i);
                                } else {
                                    validItem.add(i);
                                }
                                });
                            
                            let userEnterdISBNSort = [];
                            validItem.forEach(item => {
                                let newData = validatedISBN.filter(r => r.isbn == item);
                                if (newData) {
                                    userEnterdISBNSort.push(...newData);
                                }
                            });

                            setIsbnData(prev => (
                                {
                                    ...prev,
                                    listISBN:
                                        replaceISBNflag
                                            ? [...(Array.from(userEnterdISBNSort))]
                                            : [...(prev.listISBN), ...(Array.from(userEnterdISBNSort))],
                                    invalid:
                                        replaceISBNflag
                                            ? [...(Array.from(invalid || []))]
                                            : [...(prev.invalid), ...(Array.from(invalid))],
                                    duplicates:
                                        replaceISBNflag
                                            ? [...(Array.from(duplicates || [] ))]
                                            : [...(prev.duplicates), ...(Array.from(duplicates || []))]
                                }
                            ));
                          
                        }
                    }
                } else {
                    for (let i = 0; i < itemList.length; i += chunkSize) {
                        const chunk = itemList.slice(i, i + chunkSize);
                        const replaceISBNflag = i == 0;//to uppend or complete replace isbn list in existing list
                        chunk.forEach(item => validItem.add(item));
                        const validatedISBN = await this.inventoryPostCall("validateISBN", chunk);
                        if (replaceISBNflag) {
                            setIsbnData(prev => (
                                {
                                    ...prev,
                                    listISBN: [validatedISBN],
                                    invalid: [],
                                    duplicates:[]
                                }
                            ));
                            
                        } else {
                            setIsbnData(prev => (
                                {
                                    ...prev,
                                    listISBN: [...prev.listISBN, ...validatedISBN]
                                }));
                           
                        }
                        
                    }
                }
            }
           
            if (validItem && validItem.size > 0 && updateSetTitle) {
        
                const list =[...Array.from(validItem)];
               await this.inventoryPostCall("setTitleList", {
                    isbnList: list,
                    upn: upn,
                   flag: !prependISBN
               })
              
            }
            
        } catch(error) {
        console.error("isbn validation failed");
        } finally {
            setIsbnData(prev => ({
            ...prev,
            Loading: false
            }));

         
    }
    }


}

export const apiHelper = new ApiHelper();